module.exports = __webpack_public_path__ + "img/z_k@2x.3181282a.png";